function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-10"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.48,347.81s-7.68-15,1.1-29.86,11.32-18.32,5.72-21.36-8.16,11.86-8.16,11.86-4.72-10.25-.82-21,6.34-28.2,1-30.07-1,21.79-5.64,29.86c0,0-3.87-9-4.51-17.6s.36-22.37-3.84-25.9-6.9-1.08-2.77,17.93a179,179,0,0,1,4.1,34.46s-9.12-24.94-15.24-25.66-6.11,7.35-.87,14.35,15.34,19.56,17,26c0,0-10-18.76-19-13s7.84,17.09,15.35,21.18,12.71,29.78,12.71,29.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41,354s7.49-15.14-1.49-29.85-11.57-18.16-6-21.27,8.32,11.75,8.32,11.75,4.58-10.32.54-21-6.71-28.11-1.42-30.05,1.31,21.78,6,29.78c0,0,3.76-9,4.28-17.65s-.66-22.37,3.5-25.95,6.87-1.18,3,17.88a179.67,179.67,0,0,0-3.64,34.52s8.79-25.06,14.9-25.87,6.21,7.27,1.06,14.34-15.08,19.76-16.65,26.24c0,0,9.76-18.9,18.84-13.27s-7.61,17.19-15.06,21.39-12.32,29.94-12.32,29.94Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.93 343.19 378.11 343.19 383.11 382.87 434.93 382.87 439.93 343.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.04,
    y: 92.06,
    width: 112.62,
    height: 124.62,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 97,
    width: 103,
    height: 115,
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.11 97 222 206.02 222 147 235.32 97 251.11 97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.12 97 233.42 212 227.63 212 258.33 97 264.12 97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325 128.36 325 187.39 318.48 212 302.69 212 325 128.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.35,
    y: 92.06,
    width: 4,
    height: 124.62,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 117.35,
    width: 108.5,
    height: 4,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.04,
    y: 92.06,
    width: 112.62,
    height: 124.62,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 97,
    width: 103,
    height: 115,
    style: {
      fill: "#f4f4f4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.11 97 68 206.02 68 147 81.32 97 97.11 97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.12 97 79.42 212 73.63 212 104.33 97 110.12 97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171 128.36 171 187.39 164.48 212 148.69 212 171 128.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.35,
    y: 92.06,
    width: 4,
    height: 124.62,
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 117.35,
    width: 108.5,
    height: 4,
    style: {
      fill: "#e9e9e9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-10"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-10",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--exams-sheet--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.66,382.87H228.17a6.52,6.52,0,0,1-6.59-7.16l19.35-248.24a7.87,7.87,0,0,1,7.71-7.16H402.12a6.53,6.53,0,0,1,6.6,7.16L389.37,375.71A7.88,7.88,0,0,1,381.66,382.87Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,382.87H228.17a6.52,6.52,0,0,1-6.59-7.16l19.35-248.24a7.87,7.87,0,0,1,7.71-7.16H402.12a6.53,6.53,0,0,1,6.6,7.16L389.37,375.71A7.88,7.88,0,0,1,381.66,382.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,136.54h-73.5a2.28,2.28,0,0,1-2.31-2.5l1.13-14.51a2.76,2.76,0,0,1,2.7-2.51h73.5a2.28,2.28,0,0,1,2.3,2.51L363.56,134A2.75,2.75,0,0,1,360.87,136.54Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,136.54h-73.5a2.28,2.28,0,0,1-2.31-2.5l1.13-14.51a2.76,2.76,0,0,1,2.7-2.51h73.5a2.28,2.28,0,0,1,2.3,2.51L363.56,134A2.75,2.75,0,0,1,360.87,136.54Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,121.53h-11.5l.45-5.76a6.32,6.32,0,0,1,6.19-5.75h0a5.25,5.25,0,0,1,5.31,5.75Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,121.53h-11.5l.45-5.76a6.32,6.32,0,0,1,6.19-5.75h0a5.25,5.25,0,0,1,5.31,5.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.59 372.5 231.85 372.5 250.71 130.67 398.44 130.67 379.59 372.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2,143.33H300a5.38,5.38,0,0,1-5.43-5.9l.6-7.68a6.49,6.49,0,0,1,6.35-5.9h47.21a5.39,5.39,0,0,1,5.44,5.9l-.6,7.68A6.51,6.51,0,0,1,347.2,143.33Zm-45.86-17.47a4.28,4.28,0,0,0-4.19,3.89l-.6,7.68a3.55,3.55,0,0,0,3.58,3.9h47.22a4.29,4.29,0,0,0,4.2-3.9l.6-7.68a3.56,3.56,0,0,0-3.59-3.89Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.2,143.33H300a5.38,5.38,0,0,1-5.43-5.9l.6-7.68a6.49,6.49,0,0,1,6.35-5.9h47.21a5.39,5.39,0,0,1,5.44,5.9l-.6,7.68A6.51,6.51,0,0,1,347.2,143.33Zm-45.86-17.47a4.28,4.28,0,0,0-4.19,3.89l-.6,7.68a3.55,3.55,0,0,0,3.58,3.9h47.22a4.29,4.29,0,0,0,4.2-3.9l.6-7.68a3.56,3.56,0,0,0-3.59-3.89Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.76,128.28h-40a1.25,1.25,0,0,1-1.27-1.37l.31-4a1.52,1.52,0,0,1,1.49-1.37h40a1.24,1.24,0,0,1,1.26,1.37l-.31,4A1.51,1.51,0,0,1,344.76,128.28Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.63 166 266.63 166 267.58 153.78 379.58 153.78 378.63 166",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.3 183.01 258.74 183.01 258.99 179.86 333.55 179.86 333.3 183.01",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.6 192.11 258.04 192.11 258.28 188.95 332.84 188.95 332.6 192.11",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.89 201.21 257.33 201.21 257.57 198.05 332.13 198.05 331.89 201.21",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.18 210.3 256.62 210.3 256.86 207.15 331.42 207.15 331.18 210.3",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.1 210.3 349.68 210.3 352.06 179.86 382.48 179.86 380.1 210.3",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,191.16c.14-1.78-1.24-3-3.74-3a6.44,6.44,0,0,0-5.16,2.2l-1.92-1.45a9.41,9.41,0,0,1,7.45-3.12c4,0,6.46,1.87,6.21,5-.36,4.65-5.31,5-5.59,8.61h-2.79C366.49,195,371.43,194.36,371.68,191.16Zm-6.28,12.73a1.92,1.92,0,0,1,2-1.78,1.59,1.59,0,0,1,1.64,1.78,1.93,1.93,0,0,1-1.92,1.78A1.61,1.61,0,0,1,365.4,203.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.71 229.08 255.15 229.08 255.4 225.92 329.96 225.92 329.71 229.08",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329 238.17 254.44 238.17 254.69 235.02 329.25 235.02 329 238.17",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.3 247.27 253.74 247.27 253.98 244.12 328.54 244.12 328.3 247.27",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.59 256.37 253.03 256.37 253.27 253.21 327.83 253.21 327.59 256.37",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.51 256.37 346.09 256.37 348.46 225.92 378.88 225.92 376.51 256.37",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.09,237.23c.14-1.79-1.24-3-3.74-3a6.44,6.44,0,0,0-5.16,2.2L357.27,235a9.38,9.38,0,0,1,7.45-3.12c4,0,6.46,1.87,6.21,5-.36,4.65-5.31,5-5.59,8.61h-2.79C362.89,241,367.84,240.43,368.09,237.23ZM361.81,250a1.92,1.92,0,0,1,1.95-1.79A1.59,1.59,0,0,1,365.4,250a1.94,1.94,0,0,1-1.92,1.78A1.61,1.61,0,0,1,361.81,250Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.12 275.14 251.56 275.14 251.81 271.99 326.37 271.99 326.12 275.14",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.41 284.24 250.85 284.24 251.1 281.08 325.66 281.08 325.41 284.24",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.7 293.34 250.15 293.34 250.39 290.18 324.95 290.18 324.7 293.34",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324 302.43 249.44 302.43 249.68 299.28 324.24 299.28 324 302.43",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.92 302.43 342.5 302.43 344.87 271.99 375.29 271.99 372.92 302.43",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5,283.29c.14-1.78-1.24-3-3.75-3a6.43,6.43,0,0,0-5.15,2.2L353.68,281a9.38,9.38,0,0,1,7.45-3.12c4,0,6.45,1.86,6.21,4.95-.36,4.66-5.31,5-5.59,8.61H359C359.3,287.11,364.25,286.49,364.5,283.29ZM358.22,296a1.92,1.92,0,0,1,1.95-1.78,1.59,1.59,0,0,1,1.64,1.78,1.93,1.93,0,0,1-1.92,1.78A1.6,1.6,0,0,1,358.22,296Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.53 321.21 247.97 321.21 248.22 318.05 322.78 318.05 322.53 321.21",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.82 330.31 247.26 330.31 247.51 327.15 322.07 327.15 321.82 330.31",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.11 339.4 246.55 339.4 246.8 336.25 321.36 336.25 321.11 339.4",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.4 348.5 245.84 348.5 246.09 345.34 320.65 345.34 320.4 348.5",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.33 348.5 338.91 348.5 341.28 318.05 371.7 318.05 369.33 348.5",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.91,329.36c.14-1.79-1.24-3-3.75-3a6.42,6.42,0,0,0-5.15,2.2l-1.92-1.45a9.38,9.38,0,0,1,7.45-3.12c4,0,6.45,1.87,6.21,5-.36,4.65-5.31,5-5.59,8.61h-2.79C355.71,333.17,360.66,332.56,360.91,329.36Zm-6.28,12.73a1.92,1.92,0,0,1,1.95-1.79,1.59,1.59,0,0,1,1.64,1.79,1.94,1.94,0,0,1-1.92,1.78A1.61,1.61,0,0,1,354.63,342.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.63 166 266.63 166 267.58 153.78 379.58 153.78 378.63 166",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.3 183.01 258.74 183.01 258.99 179.86 333.55 179.86 333.3 183.01",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.6 192.11 258.04 192.11 258.28 188.95 332.84 188.95 332.6 192.11",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.89 201.21 257.33 201.21 257.57 198.05 332.13 198.05 331.89 201.21",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.18 210.3 256.62 210.3 256.86 207.15 331.42 207.15 331.18 210.3",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.1 210.3 349.68 210.3 352.06 179.86 382.48 179.86 380.1 210.3",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.71 229.08 255.15 229.08 255.4 225.92 329.96 225.92 329.71 229.08",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329 238.17 254.44 238.17 254.69 235.02 329.25 235.02 329 238.17",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.3 247.27 253.74 247.27 253.98 244.12 328.54 244.12 328.3 247.27",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.59 256.37 253.03 256.37 253.27 253.21 327.83 253.21 327.59 256.37",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.51 256.37 346.09 256.37 348.46 225.92 378.88 225.92 376.51 256.37",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.12 275.14 251.56 275.14 251.81 271.99 326.37 271.99 326.12 275.14",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.41 284.24 250.85 284.24 251.1 281.08 325.66 281.08 325.41 284.24",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.7 293.34 250.15 293.34 250.39 290.18 324.95 290.18 324.7 293.34",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324 302.43 249.44 302.43 249.68 299.28 324.24 299.28 324 302.43",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.92 302.43 342.5 302.43 344.87 271.99 375.29 271.99 372.92 302.43",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.53 321.21 247.97 321.21 248.22 318.05 322.78 318.05 322.53 321.21",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.82 330.31 247.26 330.31 247.51 327.15 322.07 327.15 321.82 330.31",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.11 339.4 246.55 339.4 246.8 336.25 321.36 336.25 321.11 339.4",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.4 348.5 245.84 348.5 246.09 345.34 320.65 345.34 320.4 348.5",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.33 348.5 338.91 348.5 341.28 318.05 371.7 318.05 369.33 348.5",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,257v27.54a21,21,0,0,1-5.85,14.57L168.45,326H183l26.7-26.28a21.08,21.08,0,0,0,6.3-15V257Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,257v27.69a20.24,20.24,0,0,1-.52,4.61,20.91,20.91,0,0,1-5.78,10.42L183,326H168.45l25.7-26.89A21,21,0,0,0,200,284.54V257Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,257v27.69a20.24,20.24,0,0,1-.52,4.61L200,283.05V257Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.34,329,136.8,411.06a3.48,3.48,0,0,1-3.37,2.61H94.94a2.08,2.08,0,0,1-1.64-.81,2.05,2.05,0,0,1-.36-1.79L114.49,329h-4.14L89.07,410.05a6.09,6.09,0,0,0,5.87,7.62h38.49a7.49,7.49,0,0,0,7.24-5.59L162.47,329Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.34,329,136.8,411.06a3.48,3.48,0,0,1-3.37,2.61H94.94a2.08,2.08,0,0,1-1.64-.81,2.05,2.05,0,0,1-.36-1.79L114.49,329h-4.14L89.07,410.05a6.09,6.09,0,0,0,5.87,7.62h38.49a7.49,7.49,0,0,0,7.24-5.59L162.47,329Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "167.15 417.67 143.6 327.87 139.73 328.88 163.01 417.67 167.15 417.67",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 417.67 191.6 327.87 187.73 328.88 211.01 417.67 215.15 417.67",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "167.15 417.67 143.6 327.87 139.73 328.88 163.01 417.67 167.15 417.67",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "215.15 417.67 191.6 327.87 187.73 328.88 211.01 417.67 215.15 417.67",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "110.35 329 114.49 329 111.24 341.37 107.41 340.2 110.35 329",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.6 327.87 148.95 348.28 144.46 346.92 139.73 328.88 143.6 327.87",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.34 329 162.47 329 155.69 354.9 151.85 353.73 158.34 329",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.05 364.15 196.54 362.77 187.73 329.13 191.6 328.03 201.05 364.15",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7,330.37,88,229.14l-.25-1.53a6.58,6.58,0,0,1,1.35-5.41,6.13,6.13,0,0,1,4.81-2.2h40.48a8.66,8.66,0,0,1,8.06,6.92l.3,1.71,18.69,101-3.94.72-18.75-101.3-.24-1.42a4.62,4.62,0,0,0-4.12-3.63H93.87a2.18,2.18,0,0,0-1.74.76,2.63,2.63,0,0,0-.48,2.17l.28,1.68,18.71,101Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.7,330.37,88,229.14l-.25-1.53a6.58,6.58,0,0,1,1.35-5.41,6.13,6.13,0,0,1,4.81-2.2h40.48a8.66,8.66,0,0,1,8.06,6.92l.3,1.71,18.69,101-3.94.72-18.75-101.3-.24-1.42a4.62,4.62,0,0,0-4.12-3.63H93.87a2.18,2.18,0,0,0-1.74.76,2.63,2.63,0,0,0-.48,2.17l.28,1.68,18.71,101Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.88,320.33h76.93a5,5,0,0,1,5,5V332a0,0,0,0,1,0,0H109.88a0,0,0,0,1,0,0v-6.69A5,5,0,0,1,114.88,320.33Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.67,
    y: 326.18,
    width: 93.35,
    height: 5.84,
    rx: 2.01,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.67,
    y: 326.18,
    width: 93.35,
    height: 5.84,
    rx: 2.01,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.33 270 97.5 270 89.92 229 140.74 229 148.26 269.62 148.33 270",
    style: {
      fill: "#B42F53"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.33,182.63s-6.39-14.84-6.94-16.43.1-9.62-.39-11-7.91-2.37-9.48-2.19-.19,12.6.46,13.58a18,18,0,0,0,2.85,2.72l5.65,17Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,210.64c4.36.69,22.21,3.27,26.2.61,3.22-2.15-5.85-37-5.85-37l8.07-3.29s19.17,42.22,8.93,51.86c-5.2,4.9-19.82,6.14-40.85,6.14Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,210.64c4.36.69,22.21,3.27,26.2.61,3.22-2.15-5.85-37-5.85-37l8.07-3.29s19.17,42.22,8.93,51.86c-5.2,4.9-19.82,6.14-40.85,6.14Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.39,228.86c-3.1.09-6.41.13-9.89.13l3-11.49A25.76,25.76,0,0,1,173.39,228.86Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.17,
    y1: 234.99,
    x2: 212.33,
    y2: 257.37,
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,248.17s16.15-.5,17.83-.67,8.67-4.17,10.17-4.33,5.5,6.16,6,7.66-11.33,5.5-12.5,5.34a18.38,18.38,0,0,1-3.67-1.44L176,256.83Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.5 409.83 174.47 408.74 175.57 389.8 167.62 390.9 166.5 409.83",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.07,407.78l-9-.57a.59.59,0,0,0-.63.51h0l-.88,7.1a1.41,1.41,0,0,0,1.31,1.5c3.14.15,4.65.06,8.61.28,2.44.14,7.23.66,10.58.33s2.94-3.63,1.5-3.79c-3.44-.39-8-2.91-10.14-4.83A2.24,2.24,0,0,0,175.07,407.78Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.83,409.32a10.21,10.21,0,0,1-2.12-.42.19.19,0,0,1-.14-.15.22.22,0,0,1,.09-.19c.27-.16,2.64-1.57,3.6-1.13a.7.7,0,0,1,.39.56,1,1,0,0,1-.29,1A2.16,2.16,0,0,1,177.83,409.32Zm1.27-1.51c-.51-.24-1.89.35-2.86.88,1.42.37,2.47.39,2.88.05a.7.7,0,0,0,.17-.66.32.32,0,0,0-.19-.27Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,408.9a.12.12,0,0,1-.08,0,.25.25,0,0,1-.1-.15c0-.07,0-2.42.82-3.15a1,1,0,0,1,.82-.21.71.71,0,0,1,.64.6c.13.89-1.17,2.49-2,2.91A.12.12,0,0,1,175.75,408.9Zm1.3-3.12a.53.53,0,0,0-.41.15c-.52.43-.65,1.75-.68,2.5a3.93,3.93,0,0,0,1.52-2.34c0-.11-.07-.25-.34-.3Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.62 390.9 175.57 389.81 174.94 400.63 167 401.33 167.62 390.9",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.82,298.51l-1.94-12.18-44.66-2.67s-4.75,25.34-1.1,32.09c6.51,12.05,41.62,6,51.89,7.15-6.14,25.11-5.54,74.18-5.54,74.18l14.67,1.12s11.29-52.87,13.57-78C195.25,303.25,181.2,303.67,166.82,298.51Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.75 397.77 181.38 398.93 182.89 391.38 163.52 390.48 163.75 397.77",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.88 402.76 192.9 403.35 197.92 385.06 189.91 384.48 184.88 402.76",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.69,402.53,185,400.11a.57.57,0,0,0-.72.36h0l-2.34,6.76a1.42,1.42,0,0,0,1,1.75c3,.79,4.53,1,8.36,2.06,2.35.65,6.93,2.15,10.28,2.53s3.63-2.94,2.25-3.39c-3.28-1.1-7.2-4.52-8.91-6.84A2.23,2.23,0,0,0,193.69,402.53Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.07,404.62a9.5,9.5,0,0,1-2-.86.16.16,0,0,1-.1-.17.2.2,0,0,1,.12-.17c.29-.1,2.91-1,3.75-.35a.7.7,0,0,1,.28.63,1,1,0,0,1-.51.94A2.13,2.13,0,0,1,196.07,404.62Zm1.55-1.22c-.45-.34-1.92,0-3,.27,1.31.66,2.34.9,2.8.65a.69.69,0,0,0,.31-.61.31.31,0,0,0-.13-.31Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.12,403.78H194a.19.19,0,0,1-.06-.17c0-.07.47-2.37,1.45-2.91a1,1,0,0,1,.84,0,.73.73,0,0,1,.51.73c-.07.89-1.67,2.19-2.57,2.43A.14.14,0,0,1,194.12,403.78ZM196,401a.54.54,0,0,0-.43.06c-.6.32-1,1.58-1.19,2.31.82-.38,1.9-1.39,2-2,0-.11,0-.25-.27-.35Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.91 384.48 197.92 385.07 195.05 395.52 187.13 394.55 189.91 384.48",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64,394.23l-14.12-4.15S195,342.5,203.5,326c-.64-.21-1.49-.48-2.54-.79-1.89-.57-4.4-1.28-7.35-2.1-20.52-5.69-62.11-16.36-62.11-16.36l19-17.73s75.68,11.54,77.25,31.48C228.5,330.09,200.64,394.23,200.64,394.23Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.7 390.39 201.7 395.2 204.75 388.13 185.99 383.21 184.7 390.39",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,325.21c-1.89-.57-4.4-1.28-7.35-2.1.59-4.84.6-10.39-1.73-13.22-4.63-5.64-16.54-8.95-23.32-10.15-5.67-1-24.72-3-24.72-3s24.72-2.37,50,5C206.32,305.4,203.89,317.61,201,325.21Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,210.64s6.48,24-1.09,75.69c-14.11-.3-37.82-.85-44.69-1-.17-7.2,5.14-42.48-1.07-76.51a94.38,94.38,0,0,1,13.53-1.34,174,174,0,0,1,19.91.43A88.8,88.8,0,0,1,166,210.64Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,210.64s6.48,24-1.09,75.69c-14.11-.3-37.82-.85-44.69-1-.17-7.2,5.14-42.48-1.07-76.51a94.38,94.38,0,0,1,13.53-1.34,174,174,0,0,1,19.91.43A88.8,88.8,0,0,1,166,210.64Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.83,252.67c-4-.88-8.77-4.73-12.7-8.53,0-6.76-.33-13.95-1.06-21.28C126.63,231.09,141.69,254.18,134.83,252.67Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12,208.82C103.83,214.33,130.67,255.73,139,260s50.67-4.67,50.67-4.67L188,246.77s-37.46.95-40.91.08S135.44,228.33,130.72,220A26.71,26.71,0,0,0,119.12,208.82Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12,208.82C103.83,214.33,130.67,255.73,139,260s50.67-4.67,50.67-4.67L188,246.77s-37.46.95-40.91.08S135.44,228.33,130.72,220A26.71,26.71,0,0,0,119.12,208.82Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185 246 187.17 257.37 191.17 256 189.67 246 185 246",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185 246 187.17 257.37 191.17 256 189.67 246 185 246",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.08 176.78 196.84 172.52 194.75 168.85 185.2 172.19 186.08 176.78",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.08 176.78 196.84 172.52 194.75 168.85 185.2 172.19 186.08 176.78",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.24,207.58s.29,4.67,9.46,9.17l6.34-4.59s1.81,11.72,3,20.47c0,0-.08-14-1.28-19.38l4.85,1.72s-4.13-7.09-11.16-8.72S130.24,207.58,130.24,207.58Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,185.16c1.12,6.43,2.12,18.19-2.45,22.37L146,211.25l6.52-3.29c-7.11-1.86-6.81-7.16-5.46-12.11Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,189.52l7.1,6.33a21.27,21.27,0,0,0-.69,3.52c-2.72-.45-6.4-3.53-6.63-6.39A9.39,9.39,0,0,1,140,189.52Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.57,167.29c-2.91,3.16-.4,6.77,8.89,11.16,2.21-4.87.86-13-2.14-14.42S147.11,164.55,144.57,167.29Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,177.23c2.36,8.37,3.32,13.38,8.54,16.81,7.86,5.15,17.49-1,17.68-9.91.16-8-3.72-20.35-12.75-21.92a11.86,11.86,0,0,0-13.47,15Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.37,176.81c.15.69.64,1.17,1.09,1.07s.69-.73.54-1.42-.63-1.17-1.08-1.08S144.27,176.12,144.37,176.81Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.22,175.12c.15.69.64,1.17,1.09,1.07s.7-.73.55-1.43-.64-1.17-1.09-1.07S152.07,174.43,152.22,175.12Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.73,176a24.9,24.9,0,0,0,4.58,5.19,4.08,4.08,0,0,1-3.17,1.33Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.69,174.8a.39.39,0,0,1-.48-.55,4.1,4.1,0,0,1,2.94-2.39.41.41,0,0,1,.47.32v0a.43.43,0,0,1-.35.47h0a3.27,3.27,0,0,0-2.3,1.91A.4.4,0,0,1,141.69,174.8Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22,171.7a.4.4,0,0,1-.42-.15,3.32,3.32,0,0,0-2.68-1.34.42.42,0,0,1-.45-.38.43.43,0,0,1,.37-.45,4.14,4.14,0,0,1,3.41,1.66.41.41,0,0,1-.07.58h0A.35.35,0,0,1,155.22,171.7Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,169c4.26.5,4.7,4.88.5,14.25-4.85-2.26-9.12-9.32-7.75-12.34S129.23,168.55,133,169Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.63,184.89a8.25,8.25,0,0,0,4.89,4c2.78.81,4.2-1.67,3.46-4.31-.67-2.38-2.93-5.67-5.73-5.32S127.37,182.52,128.63,184.89Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08,170.19s-2.11-2.72,2-8.16,14.15-7.11,21.85-5.61,3.12,10,.37,11.41l.34-1.33a23,23,0,0,1-9.5,2.58l1.52-1.41S130.58,170.8,126.08,170.19Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.63,184.82a20.79,20.79,0,0,0-.29,3.11l-.54.08c-2.48.33-3.73-.34-4.37-1.17a3.31,3.31,0,0,1-.59-1.41,3.08,3.08,0,0,1,0-.87,11.73,11.73,0,0,0,5,.36C150.3,184.88,150.63,184.82,150.63,184.82Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.78,184.92l-.11.92c-2.32.3-4,.2-4.83-.41a3.08,3.08,0,0,1,0-.87A11.73,11.73,0,0,0,149.78,184.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.8,188c-2.48.33-3.73-.34-4.37-1.17a8,8,0,0,1,2.81.18A3,3,0,0,1,149.8,188Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,203.58s7.22,5.42,11,6.67c0,0,1.78-3.34,1.05-6.1l5.47,3.81a13.51,13.51,0,0,1,0,7L146,211.25l-6.16,4.5s-9.11-2.64-9.64-8.17Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,203.58s7.22,5.42,11,6.67c0,0,1.78-3.34,1.05-6.1l5.47,3.81a13.51,13.51,0,0,1,0,7L146,211.25l-6.16,4.5s-9.11-2.64-9.64-8.17Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 153.33,
    y: 254.87,
    width: 102.01,
    height: 5.27,
    rx: 1.17,
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,255.9v2.93c0,.65-.18,1.17-.82,1.17H154.5c-.65,0-1.5-.52-1.5-1.17V255.9c0-.64.85-.9,1.5-.9h99.68C254.82,255,255,255.26,255,255.9Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,255.9v2.93c0,.65-.22,1.17-.86,1.17H154.5c-.65,0-1.5-.52-1.5-1.17V255.9c0-.64.85-.9,1.5-.9h39.64C194.78,255,195,255.26,195,255.9Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lightbulb--inject-10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.36,109.13a19.13,19.13,0,1,0-25.91,22.7,5.45,5.45,0,0,1,2.89,2.78l.65,1.47,18.41-5-.19-1.6a5.61,5.61,0,0,1,1.09-3.89A19.26,19.26,0,0,0,172.36,109.13Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,136.12s-2.77-8.69-7.66-12.54l2.71-.74.21-4.17,4.43,6.41-.36-7.8,4.37,7.11.44-4,3.87-1a22.2,22.2,0,0,0-1.07,15.11",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.48,134.66c-3.26.89-5.08,4.64-4.06,8.37s4.48,6,7.74,5.14,5.07-4.63,4.06-8.36S162.74,133.78,159.48,134.66Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.76,144.74l-6.56,1.79a6.44,6.44,0,0,1-7.76-4.06l-2.15-6.07a.92.92,0,0,1,.63-1.2L168,130.27a.92.92,0,0,1,1.15.72l1.23,6.31A6.44,6.44,0,0,1,165.76,144.74Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.76,144.74l-6.56,1.79a6.44,6.44,0,0,1-7.76-4.06l-2.15-6.07a.92.92,0,0,1,.63-1.2L168,130.27a.92.92,0,0,1,1.15.72l1.23,6.31A6.44,6.44,0,0,1,165.76,144.74Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,128.25a31,31,0,0,0-5.43-.51,22.15,22.15,0,0,0-2.71.15c-.45.07-.9.12-1.33.23-.22.06-.44.09-.65.17l-.63.2-.72.23.43-.63a24.12,24.12,0,0,0,2.87-5.8,17.83,17.83,0,0,0,.75-3.13,14.22,14.22,0,0,0,.14-1.59,14.06,14.06,0,0,0,0-1.59,11.71,11.71,0,0,0-.22-1.56l-.19-.76-.25-.75a9.55,9.55,0,0,0-.65-1.42,11.26,11.26,0,0,0-.83-1.32,13.16,13.16,0,0,0-1-1.2l-.55-.56-.6-.52c-.39-.36-.85-.64-1.26-1s-.9-.56-1.35-.85l-1-.66,1.11-.53c.53-.26,1.09-.57,1.62-.89s1.06-.65,1.58-1a26.18,26.18,0,0,0,2.93-2.32c.45-.42.89-.85,1.32-1.3s.82-.93,1.19-1.41.73-1,1-1.51a14.46,14.46,0,0,0,.87-1.59,13.42,13.42,0,0,0,.68-1.68l.26-.86.19-.89a11.83,11.83,0,0,0,.2-1.78,13.6,13.6,0,0,0-.32-3.59l-.2-.89-.28-.87c-.17-.59-.44-1.14-.66-1.71s-.54-1.1-.81-1.66l-1.43-3,2.74,1.76c.48.32,1,.63,1.57.92s1.1.57,1.66.82a27.14,27.14,0,0,0,3.44,1.33c.59.17,1.18.33,1.77.46a15.55,15.55,0,0,0,1.79.3,13.54,13.54,0,0,0,1.79.11,14.75,14.75,0,0,0,1.77-.12l.86-.15.85-.23a11.71,11.71,0,0,0,1.6-.66,5.48,5.48,0,0,0,.74-.43,5,5,0,0,0,.71-.5,13,13,0,0,0,1.3-1.16,13.28,13.28,0,0,0,1.11-1.37,12.49,12.49,0,0,0,.95-1.52c.31-.51.52-1.09.79-1.63s.43-1.14.65-1.71l1.25-3.28.62,3.42a12.2,12.2,0,0,0,.43,1.65,15.65,15.65,0,0,0,2.38,4.65,12.11,12.11,0,0,0,2.43,2.42,10.34,10.34,0,0,0,1.44.92,11,11,0,0,0,1.57.7,13.12,13.12,0,0,0,1.66.46,14.39,14.39,0,0,0,1.73.24,17,17,0,0,0,1.75,0c.59,0,1.18-.08,1.77-.13s1.18-.19,1.76-.28l1.75-.42,1.73-.52,1.71-.61,2.37-.85-1.36,2.11c-.25.37-.5.82-.73,1.25s-.44.87-.64,1.33a16.21,16.21,0,0,0-.93,2.78,12.16,12.16,0,0,0-.33,2.87,8.69,8.69,0,0,0,.49,2.78l.27.66L172,97a8.62,8.62,0,0,0,.83,1.15,9.73,9.73,0,0,0,1,1,11.27,11.27,0,0,0,1.17.89,13.15,13.15,0,0,0,1.26.76c.43.24.89.42,1.34.64l1.4.53,1.44.45,1,.32-.84.65a14.17,14.17,0,0,0-1.59,1.44,15.57,15.57,0,0,0-1.38,1.66c-.23.29-.41.6-.61.9a8.62,8.62,0,0,0-.52.94,6.23,6.23,0,0,0-.44,1,6.07,6.07,0,0,0-.33,1c-.07.35-.19.69-.23,1l-.1,1.07c0,.36,0,.72.06,1.08a4.8,4.8,0,0,0,.18,1.06,6.25,6.25,0,0,0,.28,1l.41,1a5.89,5.89,0,0,0,.51,1l.56,1,.21.35h-.39a17.17,17.17,0,0,0-4.38.58,9.59,9.59,0,0,0-2.06.81,4.57,4.57,0,0,0-.47.29,2.36,2.36,0,0,0-.45.33,3.62,3.62,0,0,0-.42.36l-.39.41.37-.43a3,3,0,0,1,.4-.39,3.13,3.13,0,0,1,.44-.36c.15-.1.3-.22.46-.31a10.27,10.27,0,0,1,2.05-.94,16.38,16.38,0,0,1,4.45-.79l-.17.35-.62-1a6,6,0,0,1-.58-1l-.47-1a5.85,5.85,0,0,1-.34-1.1,4.84,4.84,0,0,1-.24-1.13c0-.38-.09-.77-.1-1.15l0-1.17c0-.38.14-.76.2-1.14a7.17,7.17,0,0,1,.32-1.12,6.23,6.23,0,0,1,.43-1.08,8.28,8.28,0,0,1,.52-1,10.85,10.85,0,0,1,.6-1,15.58,15.58,0,0,1,1.43-1.81,15.24,15.24,0,0,1,1.69-1.61l.19,1-1.51-.43-1.49-.53c-.49-.21-1-.4-1.46-.65a12.73,12.73,0,0,1-1.39-.79,12.13,12.13,0,0,1-1.31-.95A9.68,9.68,0,0,1,171.78,99a9.18,9.18,0,0,1-1-1.33l-.41-.72-.33-.77A10,10,0,0,1,169.4,93a13.07,13.07,0,0,1,.29-3.25,18.15,18.15,0,0,1,.94-3.07c.2-.5.42-1,.66-1.46s.49-.94.8-1.43l1,1.26-1.78.65-1.81.56c-.62.17-1.24.31-1.86.46s-1.25.24-1.89.31a17.72,17.72,0,0,1-1.93.16,18.15,18.15,0,0,1-2,0,16.12,16.12,0,0,1-1.94-.26,15.82,15.82,0,0,1-1.91-.51,14.71,14.71,0,0,1-1.82-.79,12.29,12.29,0,0,1-1.69-1.06,14,14,0,0,1-2.82-2.77,16.38,16.38,0,0,1-2-3.36,17.56,17.56,0,0,1-.71-1.82,15.07,15.07,0,0,1-.52-1.93l1.87.14c-.23.62-.44,1.25-.69,1.86a20,20,0,0,1-.86,1.81,14,14,0,0,1-1,1.73,16,16,0,0,1-1.28,1.6,13.53,13.53,0,0,1-1.54,1.38,6.17,6.17,0,0,1-.86.58,8.08,8.08,0,0,1-.9.52,13.43,13.43,0,0,1-1.93.78l-1,.25-1,.18a14,14,0,0,1-2,.11,15,15,0,0,1-2-.13,18.44,18.44,0,0,1-2-.35c-.65-.14-1.29-.32-1.92-.52a27.54,27.54,0,0,1-3.66-1.44c-.6-.27-1.18-.57-1.75-.88s-1.13-.64-1.72-1l1.31-1.19c.29.6.6,1.18.86,1.8a20,20,0,0,1,.71,1.87l.3,1,.22,1a19.48,19.48,0,0,1,.3,2,17.17,17.17,0,0,1,0,2,13.59,13.59,0,0,1-.24,2l-.22,1-.3,1a15.49,15.49,0,0,1-.78,1.88,14.32,14.32,0,0,1-1,1.75A19.18,19.18,0,0,1,124.15,99c-.43.52-.87,1-1.33,1.49s-.95.92-1.44,1.36a30.15,30.15,0,0,1-3.15,2.37q-.83.54-1.68,1c-.58.32-1.15.62-1.78.9l.07-1.19c.47.32,1,.61,1.42.94s.92.67,1.33,1.07l.64.58.59.62a15.43,15.43,0,0,1,1.08,1.34,12.47,12.47,0,0,1,.89,1.49,11.57,11.57,0,0,1,.68,1.58l.25.83.18.84a12.45,12.45,0,0,1,.2,1.71,16.57,16.57,0,0,1-1.16,6.63,25,25,0,0,1-3.19,5.86l-.29-.4.67-.19c.23-.07.46-.1.69-.15.45-.1.91-.13,1.37-.19a23.15,23.15,0,0,1,2.76,0A31.89,31.89,0,0,1,128.38,128.25Z",
    style: {
      fill: "#B42F53"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,128.25a31,31,0,0,0-5.43-.51,22.15,22.15,0,0,0-2.71.15c-.45.07-.9.12-1.33.23-.22.06-.44.09-.65.17l-.63.2-.72.23.43-.63a24.12,24.12,0,0,0,2.87-5.8,17.83,17.83,0,0,0,.75-3.13,14.22,14.22,0,0,0,.14-1.59,14.06,14.06,0,0,0,0-1.59,11.71,11.71,0,0,0-.22-1.56l-.19-.76-.25-.75a9.55,9.55,0,0,0-.65-1.42,11.26,11.26,0,0,0-.83-1.32,13.16,13.16,0,0,0-1-1.2l-.55-.56-.6-.52c-.39-.36-.85-.64-1.26-1s-.9-.56-1.35-.85l-1-.66,1.11-.53c.53-.26,1.09-.57,1.62-.89s1.06-.65,1.58-1a26.18,26.18,0,0,0,2.93-2.32c.45-.42.89-.85,1.32-1.3s.82-.93,1.19-1.41.73-1,1-1.51a14.46,14.46,0,0,0,.87-1.59,13.42,13.42,0,0,0,.68-1.68l.26-.86.19-.89a11.83,11.83,0,0,0,.2-1.78,13.6,13.6,0,0,0-.32-3.59l-.2-.89-.28-.87c-.17-.59-.44-1.14-.66-1.71s-.54-1.1-.81-1.66l-1.43-3,2.74,1.76c.48.32,1,.63,1.57.92s1.1.57,1.66.82a27.14,27.14,0,0,0,3.44,1.33c.59.17,1.18.33,1.77.46a15.55,15.55,0,0,0,1.79.3,13.54,13.54,0,0,0,1.79.11,14.75,14.75,0,0,0,1.77-.12l.86-.15.85-.23a11.71,11.71,0,0,0,1.6-.66,5.48,5.48,0,0,0,.74-.43,5,5,0,0,0,.71-.5,13,13,0,0,0,1.3-1.16,13.28,13.28,0,0,0,1.11-1.37,12.49,12.49,0,0,0,.95-1.52c.31-.51.52-1.09.79-1.63s.43-1.14.65-1.71l1.25-3.28.62,3.42a12.2,12.2,0,0,0,.43,1.65,15.65,15.65,0,0,0,2.38,4.65,12.11,12.11,0,0,0,2.43,2.42,10.34,10.34,0,0,0,1.44.92,11,11,0,0,0,1.57.7,13.12,13.12,0,0,0,1.66.46,14.39,14.39,0,0,0,1.73.24,17,17,0,0,0,1.75,0c.59,0,1.18-.08,1.77-.13s1.18-.19,1.76-.28l1.75-.42,1.73-.52,1.71-.61,2.37-.85-1.36,2.11c-.25.37-.5.82-.73,1.25s-.44.87-.64,1.33a16.21,16.21,0,0,0-.93,2.78,12.16,12.16,0,0,0-.33,2.87,8.69,8.69,0,0,0,.49,2.78l.27.66L172,97a8.62,8.62,0,0,0,.83,1.15,9.73,9.73,0,0,0,1,1,11.27,11.27,0,0,0,1.17.89,13.15,13.15,0,0,0,1.26.76c.43.24.89.42,1.34.64l1.4.53,1.44.45,1,.32-.84.65a14.17,14.17,0,0,0-1.59,1.44,15.57,15.57,0,0,0-1.38,1.66c-.23.29-.41.6-.61.9a8.62,8.62,0,0,0-.52.94,6.23,6.23,0,0,0-.44,1,6.07,6.07,0,0,0-.33,1c-.07.35-.19.69-.23,1l-.1,1.07c0,.36,0,.72.06,1.08a4.8,4.8,0,0,0,.18,1.06,6.25,6.25,0,0,0,.28,1l.41,1a5.89,5.89,0,0,0,.51,1l.56,1,.21.35h-.39a17.17,17.17,0,0,0-4.38.58,9.59,9.59,0,0,0-2.06.81,4.57,4.57,0,0,0-.47.29,2.36,2.36,0,0,0-.45.33,3.62,3.62,0,0,0-.42.36l-.39.41.37-.43a3,3,0,0,1,.4-.39,3.13,3.13,0,0,1,.44-.36c.15-.1.3-.22.46-.31a10.27,10.27,0,0,1,2.05-.94,16.38,16.38,0,0,1,4.45-.79l-.17.35-.62-1a6,6,0,0,1-.58-1l-.47-1a5.85,5.85,0,0,1-.34-1.1,4.84,4.84,0,0,1-.24-1.13c0-.38-.09-.77-.1-1.15l0-1.17c0-.38.14-.76.2-1.14a7.17,7.17,0,0,1,.32-1.12,6.23,6.23,0,0,1,.43-1.08,8.28,8.28,0,0,1,.52-1,10.85,10.85,0,0,1,.6-1,15.58,15.58,0,0,1,1.43-1.81,15.24,15.24,0,0,1,1.69-1.61l.19,1-1.51-.43-1.49-.53c-.49-.21-1-.4-1.46-.65a12.73,12.73,0,0,1-1.39-.79,12.13,12.13,0,0,1-1.31-.95A9.68,9.68,0,0,1,171.78,99a9.18,9.18,0,0,1-1-1.33l-.41-.72-.33-.77A10,10,0,0,1,169.4,93a13.07,13.07,0,0,1,.29-3.25,18.15,18.15,0,0,1,.94-3.07c.2-.5.42-1,.66-1.46s.49-.94.8-1.43l1,1.26-1.78.65-1.81.56c-.62.17-1.24.31-1.86.46s-1.25.24-1.89.31a17.72,17.72,0,0,1-1.93.16,18.15,18.15,0,0,1-2,0,16.12,16.12,0,0,1-1.94-.26,15.82,15.82,0,0,1-1.91-.51,14.71,14.71,0,0,1-1.82-.79,12.29,12.29,0,0,1-1.69-1.06,14,14,0,0,1-2.82-2.77,16.38,16.38,0,0,1-2-3.36,17.56,17.56,0,0,1-.71-1.82,15.07,15.07,0,0,1-.52-1.93l1.87.14c-.23.62-.44,1.25-.69,1.86a20,20,0,0,1-.86,1.81,14,14,0,0,1-1,1.73,16,16,0,0,1-1.28,1.6,13.53,13.53,0,0,1-1.54,1.38,6.17,6.17,0,0,1-.86.58,8.08,8.08,0,0,1-.9.52,13.43,13.43,0,0,1-1.93.78l-1,.25-1,.18a14,14,0,0,1-2,.11,15,15,0,0,1-2-.13,18.44,18.44,0,0,1-2-.35c-.65-.14-1.29-.32-1.92-.52a27.54,27.54,0,0,1-3.66-1.44c-.6-.27-1.18-.57-1.75-.88s-1.13-.64-1.72-1l1.31-1.19c.29.6.6,1.18.86,1.8a20,20,0,0,1,.71,1.87l.3,1,.22,1a19.48,19.48,0,0,1,.3,2,17.17,17.17,0,0,1,0,2,13.59,13.59,0,0,1-.24,2l-.22,1-.3,1a15.49,15.49,0,0,1-.78,1.88,14.32,14.32,0,0,1-1,1.75A19.18,19.18,0,0,1,124.15,99c-.43.52-.87,1-1.33,1.49s-.95.92-1.44,1.36a30.15,30.15,0,0,1-3.15,2.37q-.83.54-1.68,1c-.58.32-1.15.62-1.78.9l.07-1.19c.47.32,1,.61,1.42.94s.92.67,1.33,1.07l.64.58.59.62a15.43,15.43,0,0,1,1.08,1.34,12.47,12.47,0,0,1,.89,1.49,11.57,11.57,0,0,1,.68,1.58l.25.83.18.84a12.45,12.45,0,0,1,.2,1.71,16.57,16.57,0,0,1-1.16,6.63,25,25,0,0,1-3.19,5.86l-.29-.4.67-.19c.23-.07.46-.1.69-.15.45-.1.91-.13,1.37-.19a23.15,23.15,0,0,1,2.76,0A31.89,31.89,0,0,1,128.38,128.25Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.648bbd2af3bb8ab2a2d4d58dda522292.svg";
export { ForwardRef as ReactComponent };